import React, {createRef, useEffect} from "react";
import ReactPlayer from "react-player/youtube";
import SectionTitle from "../SectionTitle";
import {Video, Link, Book, Film, ScrollBar, Info, VideoPallino, Lezioni, Pallino} from "./Icons";
import Footer from "../Footer";
import attestatoNove from "./attestato9.pdf";
import attestatoDodici from "./attestato12.pdf";
import energiaDue from "./energiaDue.pdf";
import missioneDue from "./missioneDue.pdf";
import azioneUno from "./azioneUno.pdf";
import azioneTre from "./azioneTre.pdf";

import {
  Wrap,
  Intro,
  VideoWrapper,
  Lessons,
  Certification,
  Links,
  FiltersTabs,
  FiltersTabList,
  FilterTab,
  FilterTabPanelLessonOne,
  FilterTabPanelLessonTwo,
  ScrollContainer,
  PallinoWrap,
} from "./styles";

export default function SectionContentAgire(props) {
  const ScrollBarWithRef = React.forwardRef((props, ref) => (
    <div ref={ref}>
      <ScrollBar />
    </div>
  ));
  const scrollRef = createRef(null);

  const imageToShow = (pos) => {
    switch (true) {
      case pos >= 0 && pos < 1237:
        return "info";
      case pos >= 1237 && pos < 1879:
        return "video";
      case pos >= 1879 && pos < 4275:
        return "lezioni";
      default:
        return "pallino";
    }
  };

  useEffect(() => {
    imageToShow(props.pos);
  }, [props.pos]);
  return (
    <Wrap>
      <ScrollContainer>
        <ScrollBarWithRef ref={scrollRef} />
      </ScrollContainer>
      <PallinoWrap opacity={imageToShow(props.pos)}>
        <Info />
        <VideoPallino />
        <Lezioni />
        <Pallino />
      </PallinoWrap>
      <Intro>
        <SectionTitle title="INTRODUZIONE" />
        <h2>{props.mainTitleFirstPart}</h2>
        {props.mainTitleSecondPart && <h2>{props.mainTitleSecondPart}</h2>}
        <section>
          <div>
            <article>{props.description}</article>
          </div>
          <div>
            {props.checkPoints.map((c, i) => (
              <span key={i}>
                <svg width="37" height="29">
                  <path
                    d="M32.107 0L37 5.108 14.111 29 0 14.27l4.893-5.107 9.218 9.622z"
                    fill="#F5A462"
                    fillRule="evenodd"
                  />
                </svg>
                {c.toUpperCase()}
              </span>
            ))}
          </div>
        </section>
      </Intro>

      <VideoWrapper>
        <div>
          <SectionTitle title="UN VIDEO PER INIZIARE" />
          <h2>{props.videoTitle}</h2>
        </div>
        <div>
          <ReactPlayer width="100%" height="auto" url="https://www.youtube.com/watch?v=uQm3XPtjrS4" />
        </div>
      </VideoWrapper>

      <Lessons>
        <div>
          <SectionTitle title="PROPOSTE DI AZIONE" />
          <h2>{props.lessonsTitleOne}</h2>
          <p>
            Due presentazioni introduttive sul tema dell'energia e della mobilità e due azioni per ridurre le emissioni
            di CO<label>2</label> degli “Agenti 0 emissioni” e della scuola in questi ambiti.
          </p>
          <span>Seleziona il tema</span>
          <div>
            <FiltersTabs>
              <FiltersTabList>
                <FilterTab>ENERGIA</FilterTab>
                <FilterTab>MOBILITÀ</FilterTab>
              </FiltersTabList>
              <FilterTabPanelLessonOne>
                <div>
                  <section>
                    <a
                      href="https://view.genial.ly/60abce8692bc460ddb2befa8/presentation-lez-31-missione-riduzione-arma-segreta-efficienza-energetica"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div></div>
                      <button>GUARDA LA LEZIONE INTERATTIVA</button>
                    </a>
                  </section>
                  <span />
                  <section>
                    <a href={energiaDue} target="_blank" rel="noopener noreferrer" >
                      <div></div>
                      <button>SCARICA LA SCHEDA ATTIVITÀ</button>
                    </a>
                  </section>
                </div>
              </FilterTabPanelLessonOne>
              <FilterTabPanelLessonOne>
                <div>
                  <section>
                    <a
                      href="https://view.genial.ly/60abd0336152820dd44f29a6/presentation-lez-32-missione-riduzione-arma-segreta-mobilita-sostenibile"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div></div>
                      <button>GUARDA LA LEZIONE INTERATTIVA</button>
                    </a>
                  </section>
                  <span />
                  <section>
                    <a href={missioneDue} target="_blank" rel="noopener noreferrer" >
                      <div></div>
                      <button>SCARICA LA SCHEDA ATTIVITÀ</button>
                    </a>
                  </section>
                </div>
              </FilterTabPanelLessonOne>
            </FiltersTabs>
          </div>
        </div>
      </Lessons>

      <Lessons bgc="rgba(245, 164, 98, 0.05);">
        <div>
          <SectionTitle title="PROPOSTE DI AZIONE" />
          <h2>{props.lessonsTitleTwo}</h2>
          <p>{props.lessonDescriptionTwo}</p>
          <div>
            <FiltersTabs>
              <FilterTabPanelLessonTwo>
                <div>
                  <section>
                    <a href={azioneUno} target="_blank" rel="noopener noreferrer" >
                      <div></div>
                      <button>SCARICA LA SCHEDA ATTIVITÀ</button>
                    </a>
                  </section>
                  <span />
                  <section>
                    <a
                      href="https://view.genial.ly/60abd08392bc460ddb2beff9/presentation-lez-34-missione-fai-sentire-la-tua-voce-arma-segreta-advocacy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div></div>
                      <button>GUARDA LA LEZIONE INTERATTIVA</button>
                    </a>
                  </section>
                </div>
                <div>
                  <section>
                    <a href={azioneTre} target="_blank" rel="noopener noreferrer" >
                      <div></div>
                      <button>SCARICA LA SCHEDA ATTIVITÀ</button>
                    </a>
                  </section>
                </div>
              </FilterTabPanelLessonTwo>
            </FiltersTabs>
          </div>
        </div>
      </Lessons>

      <Certification>
        <div>
          <SectionTitle title="ATTESTATO" />
          <h2>{props.certificateTitle}</h2>
          <p>{props.certificateDescription}</p>
          <div>
            <a href={attestatoNove} target="_blank" rel="noopener noreferrer" >
              <button>SCARICA L'ATTESTATO</button>
            </a>
            <a href={attestatoNove} target="_blank" rel="noopener noreferrer" >
              <p>“Agente 0 emissioni” | 9-11 anni</p>
            </a>
          </div>
          <div>
            <a href={attestatoDodici} target="_blank" rel="noopener noreferrer" >
              <button>SCARICA L'ATTESTATO</button>
            </a>
            <a href={attestatoDodici} target="_blank" rel="noopener noreferrer" >
              <p>“Agente 0 emissioni” | 12-14 anni</p>
            </a>
          </div>
        </div>
      </Certification>

      <Links>
        <div>
          <h2>{props.linksTitle}</h2>
        </div>

        <div>
          <h1>VIDEO</h1>
          <div>
            <div>
              <Video />
            </div>
            <a href="https://youtu.be/qMAOifX_S6k" target="_blank" rel="noopener noreferrer">
              <p>Miriam Martinelli, in piazza per la Terra | Tv200it (2019)</p>
            </a>
          </div>
          <div>
            <div>
              <Video />
            </div>
            <a href="https://youtu.be/HNZkYgORrsE" target="_blank" rel="noopener noreferrer">
              <p>
                Support the Paris Climate Agreement | Aidan Gallagher (2021) (in inglese con sottotitoli in inglese)
              </p>
            </a>
          </div>
          <div>
            <div>
              <Video />
            </div>
            <a href="https://youtu.be/Ie9cACQnqew" target="_blank" rel="noopener noreferrer">
              <p>Why you should be a climate activist | TED (2019) (in inglese con sottotitoli in italiano)</p>
            </a>
          </div>
          <div>
            <div>
              <Video />
            </div>
            <a href="https://youtu.be/BCbmQRII0V8" target="_blank" rel="noopener noreferrer">
              <p>Xiye Bastida-Patrick | Seventh Generation (2019) (in inglese con sottotitoli in inglese)</p>
            </a>
          </div>
        </div>
        <div>
          <h1>ARTICOLI E SITI WEB</h1>
          <div>
            <div>
              <Link />
            </div>
            <a href="https://childrenvsclimatecrisis.org/" target="_blank" rel="noopener noreferrer">
              <p>Children vs Climate Crisis | (2019) (in inglese)</p>
            </a>
          </div>
          <div>
            <div>
              <Link />
            </div>
            <a
              href="https://www.un.org/sustainabledevelopment/climate-action-superheroes/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>Climate action superheroes | United Nations (in inglese)</p>
            </a>
          </div>
          <div>
            <div>
              <Link />
            </div>
            <a href="https://www.green-school.it/" target="_blank" rel="noopener noreferrer">
              <p>Green School | Rete lombarda per lo sviluppo sostenibile</p>
            </a>
          </div>
        </div>
        <div>
          <h1>LIBRI E FILM</h1>
          <div>
            <div>
              <Book />
            </div>
            <p>Green Girls. Storie vere di ragazze dalla parte del Pianeta | Ruggeri C. (2021)</p>
          </div>
          <div>
            <div>
              <Film />
            </div>
            <p>I am Greta - Una forza della natura | Nathan Grossman (2020)</p>
          </div>
        </div>
      </Links>
      <Footer />
    </Wrap>
  );
}
